import { createContext } from "react";

const QuoteContext = createContext();

export default QuoteContext;